import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/** Vente flash en cours ({ code, percent, ends_at }) ou null : disparaît d'elle-même à l'heure de fin. */
export function useFlashSale() {
  const { data } = useQuery({
    queryKey: ["flash-sale"],
    queryFn: () => api.get("/flash-sale").then((r) => r.data),
    refetchInterval: 120000,
    staleTime: 60000,
    retry: false,
  });
  const [now, setNow] = useState(() => Date.now());
  const end = data?.active && data?.ends_at ? Date.parse(data.ends_at) : 0;
  useEffect(() => {
    if (!end) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (!end || end <= now) return null;
  return { code: data.code, percent: Number(data.percent) || 0, endsAt: end, left: end - now };
}

/** « plus que 3 heures » dans les 3 dernières heures, sinon null. */
/** Offre cadeau 72 h (Extrême Repouss offert avec le Pack Pouss Performance) : null hors période. */
export function useGiftOffer() {
  const { data } = useQuery({
    queryKey: ["gift-offer"],
    queryFn: () => api.get("/gift-offer").then((r) => r.data),
    refetchInterval: 120000,
    staleTime: 60000,
    retry: false,
  });
  const [now, setNow] = useState(() => Date.now());
  const end = data?.active && data?.expires_at ? Date.parse(data.expires_at) : 0;
  useEffect(() => {
    if (!end) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (!end || end <= now) return null;
  return { trigger: data.trigger, gift: data.gift, endsAt: end, left: end - now };
}

/** Lancement Lumina V.G (29,90 € pendant 72 h puis 39,90 €) : null hors période. */
export function useLuminaLaunch() {
  const { data } = useQuery({
    queryKey: ["lumina-launch"],
    queryFn: () => api.get("/lumina-launch").then((r) => r.data),
    refetchInterval: 120000,
    staleTime: 60000,
    retry: false,
  });
  const [now, setNow] = useState(() => Date.now());
  const end = data?.active && data?.expires_at ? Date.parse(data.expires_at) : 0;
  useEffect(() => {
    if (!end) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (!end || end <= now) return null;
  return { slug: data.slug, price: Number(data.price) || 0, priceAfter: Number(data.price_after) || 0, endsAt: end, left: end - now };
}

export function lastHours(ms, lang = "fr") {
  if (ms > 3 * 3600000) return null;
  const en = lang === "en";
  if (ms > 3600000) { const h = Math.ceil(ms / 3600000); return en ? `only ${h} hours left` : `plus que ${h} heures`; }
  const m = Math.max(1, Math.ceil(ms / 60000));
  return en ? `only ${m} minute${m > 1 ? "s" : ""} left` : `plus que ${m} minute${m > 1 ? "s" : ""}`;
}

export function fmtLeft(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
}
